import { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Client-side "Załaduj więcej" window over an already loaded list: shows the
 * first `pageSize` items and grows by `pageSize` on `loadMore`. The window goes
 * back to the first batch only when `resetKey` changes (filters, sort, archive
 * switch), not when the same list is refetched after an edit.
 */
export const useLoadMore = <T,>(items: T[], pageSize: number, resetKey: unknown) => {
  const [visibleCount, setVisibleCount] = useState(pageSize);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [pageSize, resetKey]);

  const visibleItems = useMemo(() => items.slice(0, visibleCount), [items, visibleCount]);
  const loadMore = useCallback(() => setVisibleCount((count) => count + pageSize), [pageSize]);

  return {
    visibleItems,
    total: items.length,
    hasMore: visibleItems.length < items.length,
    loadMore,
  };
};
